import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import palette from 'constants/palette'
import { buildTranslate } from 'locales'
import { OrderLineItem } from 'models/Order'
import Row from './Row'

const t = buildTranslate('users.view.activity.order_details.receipt')

type Props = {
  items: Array<OrderLineItem>
}

// The item price is always the whole line, for POS and digital orders alike.
const Table = ({ items }: Props) => {
  const [css] = useStyletron()

  const headCell = {
    padding: '6px 0',
    borderBottom: `1px solid ${palette.grey20}`,
  }
  const headCellClass = css({ ...headCell, textAlign: 'left' })
  const numericHeadClass = css({ ...headCell, textAlign: 'right' })

  return (
    <table className={css({ width: '100%', marginTop: '8px' })}>
      <caption className="sr-only">{t('caption_line_totals')}</caption>
      <thead>
        <tr>
          <th scope="col" className={headCellClass}>
            <Text.BodyText5 color="grey70">{t('item')}</Text.BodyText5>
          </th>
          <th scope="col" className={numericHeadClass}>
            <Text.BodyText5 color="grey70">{t('quantity')}</Text.BodyText5>
          </th>
          <th scope="col" className={numericHeadClass}>
            <Text.BodyText5 color="grey70">{t('line_total')}</Text.BodyText5>
          </th>
        </tr>
      </thead>
      <tbody>
        {items.map((item, index) => (
          <Row key={`${index}-${item.name}`} item={item} />
        ))}
      </tbody>
    </table>
  )
}

export default Table
